import { render, staticRenderFns } from "./EntityPermissions.vue?vue&type=template&id=c143d972&"
import script from "./EntityPermissions.vue?vue&type=script&lang=js&"
export * from "./EntityPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports